import { FC, useState } from "react";
import { classes, stylesheet } from "typestyle";
import { IActivityEntry } from "@hulanbv/platformapp";
import { Flex } from "../../../elements/flex.element";
import { Button } from "../../../elements/button.element";
import { Card } from "../../../elements/card.element";

type Props = {
  values: IActivityEntry[];
  onComplete: () => void;
};

const LiveYourValuesOverviewView: FC<Props> = ({ values, onComplete }) => {
  const [cardNumber, setCardNumber] = useState(0);
  return (
    <Flex
      flex={1}
      justifyContent="center"
      alignItems="stretch"
      direction="column"
      attributes={{ style: { marginBottom: 50 } }}
    >
      <p className={styles.info}>
        What is a small step you can take toward this value this week?
      </p>
      <Flex
        flex={1}
        direction="column"
        justifyContent="stretch"
        attributes={{ style: { position: "relative" } }}
      >
        {values?.map((component, index) => {
          const position = index - cardNumber;
          return (
            <Card
              key={`${component.id}-${index}`}
              attributes={{
                className: classes(
                  styles.card,
                  cardNumber > index && styles.discarded,
                ),
                style: {
                  zIndex: values.length - position,
                  transform: `translateY(${position * 15}px) scale(${
                    1 - position * 0.05
                  })`,
                  opacity: position < 0 ? 0 : 1.33 - position * 0.33,
                  pointerEvents: index === cardNumber ? "auto" : "none",
                  transition:
                    "transform 0.5s, opacity 1s, translate 0.5s, rotate 0.5s",
                },
              }}
            >
              <Flex
                direction="column"
                alignItems="stretch"
                flex={1}
                padding={20}
              >
                <p style={{ margin: 0, textAlign: "center" }}>
                  {component.value}
                </p>
              </Flex>
            </Card>
          );
        })}
      </Flex>
      <Flex direction="row" justifyContent="flex-end" flex={0}>
        <Button
          flavour="ghost-primary"
          hideSpinnerOnSubmit
          centerChildren
          attributes={{
            style: { visibility: cardNumber === 0 ? "hidden" : "visible" },
            onClick: () => {
              if (cardNumber > 0) {
                setCardNumber(cardNumber - 1);
              }
            },
          }}
        >
          Back
        </Button>
        <Button
          hideSpinnerOnSubmit
          centerChildren
          attributes={{
            onClick: () => {
              if (cardNumber < values.length - 1) {
                setCardNumber(cardNumber + 1);
              } else {
                onComplete();
              }
            },
          }}
        >
          I've thought of my next step
        </Button>
      </Flex>
    </Flex>
  );
};

export { LiveYourValuesOverviewView };

const styles = stylesheet({
  info: {
    fontSize: ".9em",
    color: "rgb(var(--rgb-color-text-tertiary))",
    textAlign: "center",
    margin: 0,
  },

  card: {
    height: "90%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "stretch",
    position: "absolute",
    translate: "0 0",
  },

  discarded: {
    translate: "-100% 0 !important",
    rotate: "-20deg",
    transformOrigin: "left bottom",
  },
});
